import React from 'react';
import { FadeIn } from './FadeIn';
export const Hero: React.FC = () => {
  return <header className="w-full pt-8 pb-6 sm:pt-14 sm:pb-10" data-id="element-155">
      <FadeIn data-id="element-156">
        <div className="max-w-[680px] mx-auto px-5 sm:px-6 text-center" data-id="element-157">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold font-serif text-navy leading-[1.15] tracking-tight mb-4 sm:mb-6" data-id="element-158">
            I Spent 14 Years Trying to Quit Porn. Then I Stopped Trying.
          </h1>
          <p className="text-sm sm:text-lg font-sans text-navy/70 mb-8 sm:mb-12" data-id="element-159">
            — Marcus, 34. Software Engineer. Father of one.
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-160">
        <div className="w-full max-w-6xl mx-auto sm:px-6" data-id="element-161">
          <img src="https://cdn.magicpatterns.com/uploads/gNEkR1wHXq7Zg7T9Uw8YBp/hero_1.png" alt="Man alone in dark room facing screen with blue monitor light" className="w-full aspect-[16/9] object-cover sm:rounded-sm shadow-2xl" data-id="element-162" />
        </div>
      </FadeIn>
    </header>;
};